// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgn_a","AdSlotBranding__desktop":"bgn_b","AdSlotBranding__mobile":"bgn_c"};